import * as React from "react";
import img1 from "../Images/img1.png";

function Section2() {
  return (
    <div className="flex justify-center items-center px-16 py-10 max-md:px-5">
      <div className="justify-center mt-5 w-full max-w-[1119px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-[55%] max-md:ml-0 max-md:w-full">
            <img
              loading="lazy"
              srcSet={img1}
              className="grow w-full aspect-[1.45] max-md:mt-10 max-md:max-w-full"
            />
          </div>
          <div className="flex flex-col ml-5 w-[45%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col self-stretch my-auto max-md:mt-10 max-md:max-w-full">
              <div className="text-4xl font-bold text-cyan-700 max-md:mr-2 max-md:max-w-full">
                Why Choose Us ?
              </div>
              <div className="mt-5 text-base font-medium tracking-wide text-black text-opacity-80 max-md:mr-2 max-md:max-w-full">
                Creating quality urban lifestyles, building stronger communities
              </div>
              <div className="mt-10 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                  <div className="flex flex-col w-[69%] max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col grow text-base font-medium text-black whitespace-nowrap max-md:mt-10">
                      <div className="flex gap-2">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/492dd0b210d6466f5016d69323e8653dd4340796f33b32a1cbaf9b347cac3096?"
                          className="shrink-0 w-5 aspect-[0.95] fill-cyan-700"
                        />
                        <div>Experienced</div>
                      </div>
                      <div className="flex gap-2 mt-7">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/492dd0b210d6466f5016d69323e8653dd4340796f33b32a1cbaf9b347cac3096?"
                          className="shrink-0 w-5 aspect-[0.95] fill-cyan-700"
                        />
                        <div>Reliable</div>
                      </div>
                      <div className="flex gap-2 mt-7">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/492dd0b210d6466f5016d69323e8653dd4340796f33b32a1cbaf9b347cac3096?"
                          className="shrink-0 w-5 aspect-[0.95] fill-cyan-700"
                        />
                        <div>Sustainable</div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[31%] max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col grow text-base font-medium text-black whitespace-nowrap max-md:mt-10">
                      <div className="flex gap-2">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/c43392e48f5beac4e4591c0384dc4233a15848e12dce213f9b3bf0b4a2e246b7?"
                          className="shrink-0 w-5 aspect-[0.95] fill-cyan-700"
                        />
                        <div>Affordable</div>
                      </div>
                      <div className="flex gap-2 mt-7">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/c43392e48f5beac4e4591c0384dc4233a15848e12dce213f9b3bf0b4a2e246b7?"
                          className="shrink-0 w-5 aspect-[0.95] fill-cyan-700"
                        />
                        <div>Customizable</div>
                      </div>
                      <div className="flex gap-2 mt-7">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/c43392e48f5beac4e4591c0384dc4233a15848e12dce213f9b3bf0b4a2e246b7?"
                          className="shrink-0 w-5 aspect-[0.95] fill-cyan-700"
                        />
                        <div>Trustworthy</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section2;
